import { createApp } from "vue";
import router from "./router";
import { createPinia } from "pinia";
import "devextreme/dist/css/dx.fluent.saas.light.compact.css";
import "vue-loading-overlay/dist/css/index.css";
import "./stylus/lib/index.styl";
import App from "./App.vue";
import { loadMessages, locale } from "devextreme/localization";
import ruMessages from "devextreme/localization/messages/ru.json";
import Popup from "devextreme/ui/popup";
import i18n from "../i18n";
import { applyDxMessageOverrides } from "./common/locales/dxOverrides";
import { applyDxGridDefaults } from "./common/helpers/dx/applyDxGridDefaults";
import { applyDxNativeScrollOnTouch } from "./common/helpers/dx/applyDxNativeScrollOnTouch";
import { applyDxMobileOverlays } from "./common/helpers/dx/applyDxMobileOverlays";
import { applyDxHeaderFilterReset } from "./common/helpers/dx/applyDxHeaderFilterReset";
import { captureAttribution } from "./common/helpers/auth/authAttribution";

// Метки и referrer снимаем ДО создания роутера: строковый redirect vue-router
// query не сохраняет, а referrer после первой SPA-навигации перестаёт быть внешним
captureAttribution();

loadMessages(ruMessages);
locale("ru");

Popup.defaultOptions({ options: { animation: null } });

const app = createApp(App);

function autoCloseDxLicense() {
  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      for (const node of Array.from(mutation.addedNodes)) {
        if (!(node instanceof HTMLElement)) continue;
        if (node.tagName.toLowerCase() === "dx-license") {
          const closeBtn = node.querySelector("div[style*='cursor: pointer']");
          if (closeBtn instanceof HTMLElement) {
            closeBtn.click();
            obs.disconnect();
            return;
          }
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

autoCloseDxLicense();

app.use(i18n);
applyDxMessageOverrides();
applyDxGridDefaults();
applyDxNativeScrollOnTouch();
applyDxMobileOverlays();
applyDxHeaderFilterReset();
app.use(createPinia());
app.use(router);

app.mount("#app");
